'use client';

import { useEffect } from 'react';
import styles from './styles.module.scss';

type Props = {
  formId: string;
};

export default function ConstantContactInlineForm({ formId }: Props) {
  useEffect(() => {
    const ctctVarScript = document.createElement('script');
    ctctVarScript.innerHTML = `var _ctct_m = "9c69d0773f641e6a916a6c154a1d137f";`;
    document.body.appendChild(ctctVarScript);

    const ctctWidgetScript = document.createElement('script');
    ctctWidgetScript.src =
      'https://static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js';
    ctctWidgetScript.async = true;
    ctctWidgetScript.defer = true;
    document.body.appendChild(ctctWidgetScript);

    return () => {
      document.body.removeChild(ctctVarScript);
      document.body.removeChild(ctctWidgetScript);
    };
  }, []);

  return (
    <div className={styles.formContainer}>
      <img
        src="https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthmaCanadaBrochureImg.svg"
        alt="Asthma Canada Brochure"
        className={styles.image}
      />

      <div className="ctct-inline-form" data-form-id={formId}></div>
    </div>
  );
}
